const BrandMark = ({ className = "w-8 h-8" }) => (
  <img
    src="/logo-proteccion-civil-vigo.png"
    alt="Protección Civil Concello de Vigo"
    className={`${className} shrink-0 object-contain`}
  />
);

export default BrandMark;
